"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildIsCallableFilter = void 0;
const core_types_1 = require("@dqm/core-types");
const filter_1 = require("@dqm/filter");
const getIsCallableFilter = () => {
    return {
        operator: "and",
        operands: [
            {
                operator: "neq",
                field: "callableAfter",
                value: null,
            },
            {
                operator: "lte",
                field: "callableAfter",
                value: new Date(),
            },
            {
                operator: "or",
                operands: [
                    {
                        operator: "eq",
                        field: "callableUntil",
                        value: null,
                    },
                    {
                        operator: "gte",
                        field: "callableUntil",
                        value: new Date(),
                    },
                ],
            },
        ],
    };
};
const buildIsCallableFilter = (filter) => {
    if (!filter) {
        return getIsCallableFilter();
    }
    if (!(0, filter_1.isExpression)(filter)) {
        throw new core_types_1.ArgumentError();
    }
    const expression = {
        operator: "and",
        operands: [getIsCallableFilter()],
    };
    expression.operands.push(filter);
    return expression;
};
exports.buildIsCallableFilter = buildIsCallableFilter;
//# sourceMappingURL=buildIsCallableFilter.js.map